import { jsx as l, jsxs as i } from "react/jsx-runtime";
import { ICONS_COLOR_MAPPING as d } from "./index.es2359.js";
const n = ({
  outline: o = "default-gray",
  color: C = "gray"
}) => {
  const e = d[o], t = d[C];
  return /* @__PURE__ */ l(
    "svg",
    {
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ i("g", { id: "State=Shown", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fill: t,
            id: "Fill",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9 13C11.2093 13 13 11.2093 13 9C13 6.79067 11.2093 5 9 5C6.79067 5 5 6.79067 5 9C5 11.2093 6.79067 13 9 13Z"
          }
        ),
        /* @__PURE__ */ i("g", { id: "Outline", children: [
          /* @__PURE__ */ l(
            "path",
            {
              fill: e,
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9 13C11.2093 13 13 11.2093 13 9C13 6.79067 11.2093 5 9 5C6.79067 5 5 6.79067 5 9C5 11.2093 6.79067 13 9 13ZM12.25 9C12.25 10.7951 10.7951 12.25 9 12.25C7.20488 12.25 5.75 10.7951 5.75 9C5.75 7.20488 7.20488 5.75 9 5.75C10.7951 5.75 12.25 7.20488 12.25 9Z"
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fill: e,
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M9 2.00024C5.687 2.00024 2.687 4.33358 0 9.00024C2.687 13.6669 5.687 16.0002 9 16.0002C12.313 16.0002 15.313 13.6669 18 9.00024C15.313 4.33358 12.313 2.00024 9 2.00024ZM9 15.2502C6.17443 15.2502 3.44597 13.3239 0.869163 9.00025C3.44597 4.67656 6.17443 2.75024 9 2.75024C11.8256 2.75024 14.554 4.67656 17.1308 9.00025C14.554 13.3239 11.8256 15.2502 9 15.2502Z"
            }
          )
        ] })
      ] })
    }
  );
};
n.__tags = ["eye", "view", "display"];
export {
  n as UtilityEyeIcon
};
//# sourceMappingURL=index.es424.js.map
